import { render, staticRenderFns } from "./MeasurementsPage.vue?vue&type=template&id=1fa9771e"
import script from "./MeasurementsPage.vue?vue&type=script&lang=ts"
export * from "./MeasurementsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports